import React from "react";

import {
  Stack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  HStack,
  Text,
} from "@chakra-ui/react";

import routes from "routes.js";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
// chakra imports
import { Box, Flex, Icon, useColorModeValue } from "@chakra-ui/react";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
// import PropTypes from "prop-types";

// Assets

import MainDashboard from "views/admin/uploadFilePage";

import { useSelector } from "react-redux";
import { selectSelectedModules } from "redux/selectorFunctions";

import { MdHome } from "react-icons/md";

import { FaNotesMedical } from "react-icons/fa";

import { BsDot } from "react-icons/bs";

// Admin Imports
import GetClaimPage from "views/admin/getClaimPage";
import CheckClaimDataPage from "views/admin/checkClaimDataPage";

import { NavLink, useLocation } from "react-router-dom";
import { documentTypes } from "./components/helper";

import { scrollToTextContent } from "views/moduleFlow/SelectModulePage/helper";

import {
  FaMoneyCheck,
  FaScroll,
  FaUserFriends,
  FaPollH,
  FaElementor,
  FaFontAwesome,
} from "react-icons/fa";

import { MdAccountBalance } from "react-icons/md";

function Sidebar(props) {
  let location = useLocation();
  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";

  const selectSelectedModulesRedux = useSelector(selectSelectedModules);

  function preDefinedRoutes(modules_id) {
    const first = [
      {
        name: "Preview",
        layout: "/admin",
        path: `/check-data?id=${modules_id}`,
        icon: (
          <Icon
            as={BsDot}
            width="20px"
            height="20px"
            marginLeft="15px"
            color="inherit"
          />
        ),
        component: MainDashboard,
        module: modules_id,
      },
    ];
    const second = [
      {
        name: "Claims",
        layout: "/admin",
        path: "/claim",
        icon: (
          <Icon
            as={BsDot}
            width="20px"
            height="20px"
            marginLeft="15px"
            color="inherit"
          />
        ),
        component: GetClaimPage,
        secondary: true,
        module: modules_id,
      },

      {
        name: "Report",
        layout: "/admin",
        path: "/report",
        icon: (
          <Icon
            as={BsDot}
            width="20px"
            height="20px"
            marginLeft="15px"
            color="inherit"
          />
        ),
        component: CheckClaimDataPage,
        module: modules_id,
      },
    ];

    if ([23].includes(modules_id)) {
      return first;
    } else {
      return [...first, ...second];
    }
  }

  // Function to generate routes based on the list object
  const generateRoutes = (modules_v5, routes) => {
    const new_list = [];
    if (modules_v5.length !== 0) {
      for (let index = 0; index < modules_v5.length; index++) {
        const moduleName = modules_v5[index].module_name;

        // Check if a route with the same name already exists in the routes array
        const routeExists = routes.some((route) => route.name === moduleName);

        if (!routeExists) {
          new_list.push(
            {
              name: modules_v5[index].module_name,
              layout: "/admin",
              path: "/select-module-page", // You can customize the path as needed
              icon: (
                <Icon
                  as={index === 0 ? MdHome : FaNotesMedical} // You can customize the icons as needed
                  width="20px"
                  height="20px"
                  marginLeft="20px"
                  color="inherit"
                />
              ),
              component: MainDashboard,
              module: modules_v5[index].module_id,
            },
            ...preDefinedRoutes(modules_v5[index].module_id)
          );
        }
      }
    }

    return new_list;
  };

  function routesLogic(routes) {
    const insertIndex = routes.findIndex((route) => route.name === "Modules");
    const generatedRoutes = generateRoutes(selectSelectedModulesRedux, routes);
    routes.splice(insertIndex + 1, 0, ...generatedRoutes);

    return routes;
  }

  // SIDEBAR

  let activeIcon = useColorModeValue("brand.500", "white");
  let activeColor = useColorModeValue("gray.700", "white");

  const typeToIcon = {
    "Health Care": FaNotesMedical, // Change "Type1" to the actual value in your data
    "Tax Forms": FaMoneyCheck,
    "Business and Partnership Tax Forms": FaScroll,
    "Investment and Retirement Tax Forms": FaUserFriends,
    "Financial Documents": FaPollH,
    "Legal and Identity Documents": MdAccountBalance,
    "Invoices and Statements": FaElementor,
    "Real Estate and Housing": MdHome,
    Miscellaneous: FaFontAwesome,
  };

  function moduleAccordian() {
    return (
      <Accordion allowToggle>
        <AccordionItem border={0}>
          <NavLink to="/select-module-page">
            <AccordionButton p={0} _hover={{ bg: "transparent !important" }}>
              <HStack spacing="26px" py="5px" ps="10px">
                <>
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box color={activeColor} me="18px">
                      <Icon
                        as={MdHome}
                        width="20px"
                        height="20px"
                        color={
                          location.pathname.includes("/select-module-page")
                            ? "#422AFB"
                            : "secondaryGray.600"
                        }
                      />
                    </Box>
                    <Text
                      me="auto"
                      color={
                        location.pathname.includes("/select-module-page")
                          ? "black"
                          : "secondaryGray.600"
                      }
                      fontWeight={
                        location.pathname.includes("/select-module-page")
                          ? "semibold"
                          : "normal"
                      }
                    >
                      Modules
                    </Text>
                  </Flex>
                  <Box h="36px" w="4px" bg={"transparent"} borderRadius="5px" />
                </>
              </HStack>

              <AccordionIcon
                ml={10}
                color={
                  location.pathname.includes("/select-module-page")
                    ? "black"
                    : "secondaryGray.600"
                }
              />
            </AccordionButton>
          </NavLink>

          <AccordionPanel pb={4}>
            {documentTypes.map((d) => (
              <HStack
                cursor="pointer"
                spacing="26px"
                py="5px"
                ps="10px"
                onClick={() => {
                  scrollToTextContent(d.type_name);
                }}
              >
                <>
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box color={activeColor} me="18px">
                      <Icon
                        as={typeToIcon[d.type_name]}
                        width="17px"
                        height="17px"
                        color="#422AFB"
                      />
                    </Box>
                    <Text
                      me="auto"
                      color={activeColor}
                      fontWeight="normal"
                      fontSize={14}
                    >
                      {d.type_name}
                    </Text>
                  </Flex>
                  <Box h="36px" w="4px" bg={"transparent"} borderRadius="5px" />
                </>
              </HStack>
            ))}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    );
  }

  return (
    <Box
      display={{ sm: "none", xl: "block" }}
      w="100%"
      position="fixed"
      minH="100%"
    >
      <Box
        bg={sidebarBg}
        transition={variantChange}
        w="300px"
        h="100vh"
        m={sidebarMargins}
        minH="100%"
        overflowX="hidden"
        boxShadow={shadow}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <Flex
            direction="column"
            height="100%"
            pt="25px"
            px="16px"
            borderRadius="30px"
          >
            <Brand />
            <Stack direction="column" mb="auto" mt="8px">
              <Box ps="7px" pe={{ md: "16px", "2xl": "1px" }}>
                <Links routes={routes} moduleAccordian={moduleAccordian} />
              </Box>
            </Stack>
          </Flex>
        </Scrollbars>
      </Box>
    </Box>
  );
}

export default Sidebar;
